// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'expense-payment.page.title': 'Expense Payments',
    'expense-payment.page.create.title': 'Record Payment',
    'expense-payment.page.edit.title': 'Edit Expense Payment',
    'expense-payment.page.title.redo': 'Redo Payment',

    'expense-payment.button.cancel': 'Cancel',
    'expense-payment.button.create': 'Record Payment',
    'expense-payment.button.new': 'Record Payment',
    'expense-payment.button.save': 'Save Changes',
    'expense-payment.button.refund': 'Refund Payment',
    'expense-payment.button.payments': 'Payment History',
    'expense-payment.button.void': 'Void Payment',
    'expense-payment.button.rollback': 'Rollback Payment',
    'expense-payment.button.redo': 'Redo',

    'expense-payment.link.expense_payments': ' Return to Expense Payments',
    'expense-payment.link.retry': 'Click here to retry',

    'expense-payment.label.expense_name': 'Expense Name',
    'expense-payment.label.transaction_date': 'Transaction Date',
    'expense-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'expense-payment.label.is_reconciled': 'Is Reconciled',
    'expense-payment.label.payment_method': 'Payment Method',
    'expense-payment.label.reference_code': 'Reference Code',
    'expense-payment.label.memo': 'Memo',
    'expense-payment.label.currency_name': 'Currency',
    'expense-payment.label.currency_amount_in_cents': 'Transaction Amount',
    'expense-payment.label.base_amount_in_cents': 'Base Amount in Cents',
    'expense-payment.label.cancelled_on': 'Cancelled On',
    'expense-payment.label.cancellation_reason': 'Cancellation Reason',
    'expense-payment.label.reason_for_void': 'Reason for voiding',
    'expense-payment.label.rollback_reason': 'Reason for rollback',
    'expense-payment.label.refund_reason': 'Reason for refund',
    'expense-payment.label.status': 'Status',
    'expense-payment.label.available_credit': 'Available Credit',
    'expense-payment.label.use_credit': 'Use Available Credit',
    'expense-payment.label.issue_credit': 'Issue Credit',
    'expense-payment.label.issue_refund': 'Issue Refund',

    'expense-payment.message.no_payment': 'No payment has been recorded as yet.',

    'expense-payment.modal.title.expense_payment_void': 'Void Payment',
    'expense-payment.modal.title.expense_payment_refund': 'Refund Payment',
    'expense-payment.modal.title.expense_payment_rollback': 'Rollback Payment',
    'expense-payment.modal.title.expense_overpayment': 'This is an overpayment',

    'expense-payment.success.message.expense_payment_created': 'Your expense payment has been created',
    'expense-payment.success.message.expense_payment_updated': 'Your expense payment has been updated',
    'expense-payment.success.message.expense_payment_voided': 'Your expense payment has been voided',
    'expense-payment.success.message.expense_payment_refunded': 'Your expense payment has been refunded',
    'expense-payment.success.message.expense_payment_rolled_back': 'Your expense payment has been rolled back',
    'expense-payment.success.message.expense_payment_redone': 'Your expense payment has been redone',

    'expense-payment.error.message.error_loading_page': 'Sorry, there was an error loading expense payment.| Sorry, there was an error loading expense payments.',
};
